import { render, staticRenderFns } from "./OrderPageSkeleton.vue?vue&type=template&id=a19a8e40&scoped=true&"
import script from "./OrderPageSkeleton.vue?vue&type=script&lang=js&"
export * from "./OrderPageSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./OrderPageSkeleton.vue?vue&type=style&index=0&id=a19a8e40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a19a8e40",
  null
  
)

export default component.exports